import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { MessageCircle } from 'lucide-react'
import { ContactScreen } from '@/screens/help/SCR-176-contact'

// SCR-176 Contact support (help area).
export const Route = createFileRoute('/_app/help/contact')({
  staticData: { screen: { id: 'SCR-176', title: 'Contact support', group: 'Help', order: 2, description: 'Ask the ESM team for help and follow your requests.', icon: MessageCircle } },
  validateSearch: z.object({
    /** The request open in the thread view. */
    ticket: z.string().max(100).optional().catch(undefined),
    /** Where the person came from (console path), attached to a new request. */
    from: z.string().max(300).regex(/^\//).optional().catch(undefined),
    screen: z.string().max(20).regex(/^SCR-\d+$/i).optional().catch(undefined),
    subject: z.string().max(160).optional().catch(undefined),
    status: z.enum(['active', 'resolved', 'all']).optional().catch(undefined),
  }),
  component: ContactScreen,
})
